import { useLocation } from "react-router-dom";

export function useLocationSlugCollection() {
  const { pathname } = useLocation();
  const splittedPathname = pathname.split("/");

  return splittedPathname;
}
